import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// 引入模块
import app from './modules/app';
import user from './modules/user';

const store = new Vuex.Store({
  modules: {
    app,
    user
  },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    sidebar: state => state.app.sidebar,
    device: state => state.app.device
  },
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
